import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import { dimensions, styles } from './LoadingConfig.styles';

const subTrayCardsLoadingConfig = {
  circle: [
    {
      left: null,
      main: setLoadingConfigObject('circle', 1, dimensions.circle, styles.circle),
      right: null,
    },
  ],
  firstLine: [
    {
      left: null,
      main: setLoadingConfigObject('line', 1, dimensions.firstLine, styles.firstLine),
      right: null,
    },
  ],
  secondLine: [
    {
      left: null,
      main: setLoadingConfigObject('line', 1, dimensions.secondLine, styles.secondLine),
      right: null,
    },
  ],
};

export { subTrayCardsLoadingConfig, shimmerPlaceholderConfig };
